import { SystemProvider } from '@rahtab/system';
import { isStandalone } from '@rahtab/ui';
import React, { Suspense } from 'react';
import { I18nManager } from 'react-native';
import Router from './Router';
import ApolloProvider from './components/ApolloProvider';
import AuthJsonProvider from './components/AuthJSONProvider';
import Loading from './components/Loading';
import { reducer } from './rahtab-redux/store';
import InstallPWA from './screens/InstallPWA';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { version } from '../package.json';

I18nManager.allowRTL(true);
I18nManager.forceRTL(true);

const splashscreenImage = require('../assets/images/splashscreen_image.png');

export default function App() {
  return (
    <SystemProvider reducers={reducer} splash={splashscreenImage} version={version}>
      <AuthJsonProvider>
        <ApolloProvider>
          <Suspense fallback={Loading}>{!isStandalone() ? <InstallPWA /> : <Router />}</Suspense>
        </ApolloProvider>
      </AuthJsonProvider>
    </SystemProvider>
  );
}

serviceWorkerRegistration.unregister();
